import styled from 'styled-components';

export const ListingCardContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 96px;
  gap: 12px;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const ListingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`;

export const ListingTitleRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const ListingMetaRow = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;

export const StatusPill = styled.span`
  background: ${({ $sold }) => ($sold ? 'rgba(40, 167, 69, 0.18)' : 'rgba(255, 255, 255, 0.1)')};
  border: 1px solid ${({ $sold }) => ($sold ? 'rgba(40, 167, 69, 0.5)' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 4px;
  color: ${({ $sold }) => ($sold ? '#8FD79F' : 'rgba(255, 255, 255, 0.85)')};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 3px 8px;
  text-transform: uppercase;
`;

export const CardCountText = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  white-space: nowrap;
`;

export const ListingTitle = styled.h3`
  font-weight: 600;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;

export const StatRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 24px;
    text-align: center;
    width: 100%;
`;

export const Stat = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    align-items: center;
    width: 33%;
`;

export const StatLabel = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    width: 100%;
`;

export const StatValue = styled.span`
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 600;
    width: 100%;
`;